import { Routes, Route, Navigate } from "react-router-dom";
import history from "../history";
import { CustomRouter } from "./CustomRouter";
import { paths } from "../common/constants/Rutas";
import Login from "../containers/Login/Login";
import ForgotPassword from "../containers/ForgotPass";
import HomePage from "../containers/HomePage/HomePage";
import ResultSearchPage from "../containers/ResultSearch/index";
import TicketPage from "../containers/TicketPage";
import UnificarCURP from "../containers/UnificarCURP";
import SnackbarProvider from "../providers/snackbar";
import SettingsProvider from "../providers/settings/index";
import { PublicRoute } from "./PublicRoute";
import { PrivateRoute } from "./PrivateRoute";


function AppRouter() {
	return (
		<CustomRouter 
			basename={paths.basename} 
			history={history}
		>
			<SnackbarProvider>
				<SettingsProvider>
					<Routes>
						<Route
							id="login"
							path={paths.Login}
							name="Iniciar Sesión"
							element={
								<PublicRoute>
									<Login />
								</PublicRoute>
							}
						/>
						<Route
							id="forgotPass"
							path={paths.RecuperarPassword}
							name="Recuperar Contraseña"
							element={
								<PublicRoute>
									<ForgotPassword />
								</PublicRoute>
							}
						/>
						<Route
							id="home-page"
							path={paths.HomePage}
							name="Home Page"
							element={
								<PrivateRoute> 
									<HomePage /> 
								</PrivateRoute>
							}
						/>
						<Route
							id="result-page"
							path={paths.ResultSearchPage}
							name="Result Search Page"
							element={
								<PrivateRoute> 
									<ResultSearchPage /> 
								</PrivateRoute>
							}
						/>
						<Route
							id="ticket-page"
							path={paths.TicketPage}
							name="Ticket Page"
							element={
								<PrivateRoute> 
									<TicketPage /> 
								</PrivateRoute>
							}
						/>
						<Route
							id="unificar-page"
							path={paths.UnificarCURPS}
							name="Unificar CURP"
							element={
								<PrivateRoute> 
									<UnificarCURP /> 
								</PrivateRoute>
							}
						/>
						<Route
							id="dynamic-route"
							path="/*"
							element={
								<PrivateRoute>
									<Navigate
										to={paths.HomePage}
										replace
									/>
								</PrivateRoute>
							}
						/>
					</Routes>
				</SettingsProvider>
			</SnackbarProvider>
		</CustomRouter>
	);
};

export default AppRouter;
